module.exports = __webpack_public_path__ + "img/BlinkArt_Staff_Medium.aaefaec1.png";